import { getAccountForPortal, msalInstance } from "@config/auth/msalConfig";
import { usePortalModeStore } from "@stores/usePortalModeStore";
import { useStaffOverrideStore } from "@stores/useStaffOverrideStore";
import type { RequestLogProperties } from "./requestLogContext";

export function frontendErrorContext(): RequestLogProperties {
	const { hostMode, viewMode } = usePortalModeStore.getState();
	const title = (mode: string) => mode[0].toUpperCase() + mode.slice(1);
	const properties: RequestLogProperties = {
		RequestContextSource: "Browser", AuthenticationStatus: "Unverified",
		ImpersonationStatus: "None", HostMode: title(hostMode), ViewMode: title(viewMode),
	};
	const account = getAccountForPortal(msalInstance.getAllAccounts(), hostMode);
	if (account) {
		properties.Requester = account.username;
		properties.RequesterId = account.localAccountId;
		properties.RequesterTenantId = account.tenantId;
	}
	const { override, overrideType } = useStaffOverrideStore.getState();
	if (hostMode === "staff" && override && overrideType) {
		properties.ImpersonationStatus = "Requested";
		properties.ImpersonatedUser = override.replace(/^(student|parent):/i, "");
		properties.ImpersonatedHostMode = title(overrideType);
	}
	return properties;
}
